import { MmPatch } from '@docma-mm-core/patch/mm-patch';
import { datepickerAnimation } from 'ngx-bootstrap/datepicker/datepicker-animations';
import { ChangeStatusEnum } from './change-status.enum';

export class ChangeState<T> {

  constructor(init?: Partial<ChangeState<T>>) {
    if (init)  {
      Object.assign(this, init);
      if (this.date) {
        this.date = new Date(this.date);
      }
    }
    if (!this.data) {
        this.data = {} as T;
    }

    if (!this.date) {
      this.date = new Date(Date.now());
    }
  }
  data: T;
  date: Date;
  status: ChangeStatusEnum;
}
